








































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { instrumentador } from '@/utils/common'
import { IMedicoSolicitanteHospital } from '@/types/interfaces/medico-solicitante-hospital.interface'
import EventBus from '@/plugins/EventBus'
import { C } from '@fullcalendar/core/internal-common'

@Component
export default class ComponentModalSolicitacaoCirurgiaHospitalOpcoes extends Vue {
  isInstrumentador: boolean = false
  hospital: IMedicoSolicitanteHospital = {} as any
  tipoDeCirurgia: 'normal' | 'orcamentoAvulso' = 'normal'
  hospitalTermsOfUseModal: boolean = false
  hospitalTermsOfUseFileSource: string
  hospitalTermsOfUseAcceptance: boolean = false
  loadingHealthInsuranceList: boolean = false

  tiposDeCirurgia = [
    {
      id: 'normal',
      nome: 'Solicitação',
    },
    {
      id: 'orcamentoAvulso',
      nome: 'Orçamento Avulso',
    },
  ]

  get isSurgeryCreationButtonDisabled() {
    if (!!this.hospital.id && this.selectedHospitalHasTermsOfUse && !this.hospitalTermsOfUseAcceptance) {
      return true
    }

    if (this.canShowTipoDeCirurgiaField) {
      return !(this.getSolicitacaoStore.solicitacao.hospitalId && this.tipoDeCirurgia)
    }

    return !this.getSolicitacaoStore.solicitacao.hospitalId
  }

  get canShowTipoDeCirurgiaField() {
    if (this.hospital.hospitalFazOrcamentoParticularAvulso) {
      return true
    }
    return false
  }

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get solicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get showModalHospitalOpcoes() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showHospitalOpcoes
  }

  set showModalHospitalOpcoes(value: boolean) {
    this.getSolicitacaoStore.showModalHospitalOpcoes(value)
  }

  get selectedHospitalHasTermsOfUse() {
    const hospitalId = this.hospital.id && this.hospital.id.toLowerCase()
    const selectedHospitalData = this.getSolicitacaoStore.currentUserHospitals.find(hospital => hospitalId === hospital.id)
    const hospitalHasTermsOfUse = selectedHospitalData && selectedHospitalData.hospitalPossuiTermoDeUso

    return !!(this.hospital.id && hospitalHasTermsOfUse)
  }

  get userAcceptedHospitalTermsOfUse() {
    const hospitalId = this.hospital.id && this.hospital.id.toLowerCase()

    const selectedHospitalData = this.getSolicitacaoStore.currentUserHospitals.find(hospital => hospitalId === hospital.id)
    const userAcceptedHospitalTermsOfUse = selectedHospitalData && selectedHospitalData.termoDeUsoAceitoPeloUsuario

    return !!(this.hospital.id && userAcceptedHospitalTermsOfUse)
  }

  get hospitalHasAuthorizationConfiguration() {
    return this.hospital && !!this.hospital.id && this.hospital.hospitalIntegraComAutorizadorAntesDaReserva
  }

  get healthInsuranceList() {
    return this.solicitacaoCirurgiaStore.convenios
  }

  get patientData() {
    return this.solicitacaoCirurgiaStore.solicitacaoCirurgia.paciente
  }

  async hospitalChange(data: IMedicoSolicitanteHospital) {
    this.getSolicitacaoStore.solicitacao.hospitalId = data.id
    this.tipoDeCirurgia = 'normal'

    if (this.selectedHospitalHasTermsOfUse) {
      this.hospitalTermsOfUseAcceptance = this.userAcceptedHospitalTermsOfUse
    }

    if (this.hospitalHasAuthorizationConfiguration) {
      this.loadingHealthInsuranceList = true

      this.solicitacaoCirurgiaStore.solicitacaoCirurgia.hospitalId = data.id
      await this.solicitacaoCirurgiaStore.getAllConvenio({ somenteParticulares: false })

      this.loadingHealthInsuranceList = false
    }
  }

  closeModalHospitalOpcoes() {
    this.getSolicitacaoStore.clearSolicitacao()
    this.getSolicitacaoStore.showModalHospitalOpcoes(false)
    this.hospital = {} as any
    this.tipoDeCirurgia = 'normal'
  }

  clear() {
    this.getSolicitacaoStore.setMedicoId('')
    this.getSolicitacaoStore.setMedicos([])
    this.getSolicitacaoStore.setHospitalId('')
  }

  async LoadHospitalByMedico(medicoId: string) {
    this.getSolicitacaoStore.setMedicoId(medicoId)
    this.getSolicitacaoStore.setHospitalId('')
    await this.getSolicitacaoStore.LoadHospitais(medicoId)

    if (this.getSolicitacaoStore.hospitais.length === 1) {
      const { id } = this.getSolicitacaoStore.hospitais[0]
      await this.getSolicitacaoStore.setHospitalId(id)
    }
  }

  async openHospitalUseTerms(hospitalInfo: IMedicoSolicitanteHospital) {
    try {
      EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })

      const hospitalTermsOfUseData = await this.getSolicitacaoStore.getHospitalTermsOfUse(hospitalInfo.id)
      const hospitalTermsOfUseFileData = hospitalTermsOfUseData.file

      const base64String = hospitalTermsOfUseFileData
      const byteCharacters = atob(base64String)

      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)

      const fileBlob = new Blob([byteArray], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(fileBlob)

      this.hospitalTermsOfUseFileSource = fileURL

      this.hospitalTermsOfUseModal = true
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar termos de uso, tente novamente.', icon: 'warning', color: '#C62828' })
    } finally {
      EventBus.$emit('clearLoadingRequest')
    }
  }

  async redirectToCirurgia() {
    let medicoSolicitante: any = { }
    if (this.isInstrumentador) {
      // eslint-disable-next-line
      const medico = this.getSolicitacaoStore.medicos.filter(p => p.id === this.getSolicitacaoStore.solicitacao.medicoSolicitanteId)[0]
      medicoSolicitante = {
        medicoId: medico.id,
        medico: medico.nome,
      }
    } else {
      medicoSolicitante = {
        medicoId: this.$user.profile.sub,
        medico: this.$user.profile.name,
      }
    }

    if (this.hospitalHasAuthorizationConfiguration && !this.patientData.convenioId) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha dados de convênio', icon: 'warning', color: '#C62828' })
      return
    }

    if (!!this.hospital.id && this.selectedHospitalHasTermsOfUse && this.hospitalTermsOfUseAcceptance) {
      await this.getSolicitacaoStore.acceptHospitalTermsOfUse(this.hospital.id)
    }

    const hospital = this.getSolicitacaoStore.hospitais.filter(p => p.id === this.getSolicitacaoStore.solicitacao.hospitalId)[0]
    const template = await this.getSolicitacaoStore.loadHospitalTemplate(this.getSolicitacaoStore.solicitacao.hospitalId)

    this.getSolicitacaoStore.showModalHospitalOpcoes(false)

    const route: any = {
      name: 'SolicitacaoCirurgia',
      view: 'solicitacao-cirurgia',
      path: '/solicitacao-cirurgia/:solicitacaoId?/:hospitalId?/:medicoId?/:medico?',
      params: {
        hospitalId: this.getSolicitacaoStore.solicitacao.hospitalId,
        medicoId: medicoSolicitante.medicoId,
        medico: medicoSolicitante.medico,
        hospitalNome: hospital.nome,
        solicitacaoId: 'new',
      },
      query: {},
      meta: {
        showMenu: false,
        keyAuthorized: 'agendamento-medico',
      },
    }

    // eslint-disable-next-line default-case
    switch (this.tipoDeCirurgia) {
      case 'orcamentoAvulso':
        route.query.budgetMode = true
        break
    }

    this.$router.push(route)
  }

  get getInstrumentador() {
    return this.isInstrumentador
  }

  set getInstrumentador(value) {
    this.isInstrumentador = value
  }

  async Init() {
    this.getInstrumentador = instrumentador(this.$user.profile)
    if (this.isInstrumentador) {
      const request = await this.getSolicitacaoStore.LoadAllMedicoByInstrumentadorId(this.$user.profile)
      if (request && request.length === 1) {
        const medicoByInstrumentador = request[0]

        this.getSolicitacaoStore.setMedicoId(medicoByInstrumentador.id)
        await this.getSolicitacaoStore.LoadHospitais(medicoByInstrumentador.id)

        if (this.getSolicitacaoStore.hospitais.length === 1) {
          const { id } = this.getSolicitacaoStore.hospitais[0]

          await this.getSolicitacaoStore.setHospitalId(id)
        }
      }
    } else {
      this.getSolicitacaoStore.setMedicoId(this.$user.profile.sub)
      await this.getSolicitacaoStore.LoadHospitais(this.$user.profile.sub)

      if (this.getSolicitacaoStore.hospitais.length === 1) {
        this.getSolicitacaoStore.setHospitalId(this.getSolicitacaoStore.hospitais[0].id)
      }
    }
  }

  async mounted() {
    await this.Init()
  }
}

